/**
 * Backoffice Router Configuration
 *
 * Pure route configuration without auth dependencies.
 * Auth connection is done in app.ts via connectRouterToAuth().
 */

import { WowRouter, initRouter } from "ui-components/router/wow-router";

import { AppLayout } from "./components/app-layout/app-layout";
import { AnalyticsPage, LinksPage, PostsPage, ProfilePage, SettingsPage, WowPage404 } from "./pages";
import { EmailConfirmationPage } from "./pages/email-confirmation";
import { ForgotPasswordPage } from "./pages/forgot-password";
import { ResetPasswordPage } from "./pages/reset-password";
import { SignInPage } from "./pages/sign-in";
import { SignUpPage } from "./pages/sign-up";
import { OnboardCreatorPage } from "./pages/onboard-creator/onboard-creator";
import { WorldsPage } from "./pages/worlds-page";
import { PurchasesPage } from "./pages/purchases-page";
import { LiveEventsPage } from "./pages/live-events-page/live-events-page";
import { ChangePasswordPage } from "./pages/change-password";
import { VerifyPurchasePage } from "./pages/verify-purchase";

const routerModule = initRouter(
  {
    "sign-in": { page: SignInPage, isDefault: true, layout: undefined, title: "Sign In" },
    "sign-up": { page: SignUpPage, layout: undefined, title: "Sign Up" },
    "onboard-creator": { page: OnboardCreatorPage, layout: undefined },
    "onboard-creator?step=1": { page: OnboardCreatorPage, layout: undefined },
    "sign-up/confirm-email": { page: EmailConfirmationPage, layout: undefined },
    "email-confirmation": { page: EmailConfirmationPage, layout: undefined, title: "Email Confirmation" },
    "forgot-password": { page: ForgotPasswordPage, layout: undefined, title: "Reset Password" },
    "reset-password": { page: ResetPasswordPage, layout: undefined, title: "Reset Password" },
    "change-password": { page: ChangePasswordPage, layout: undefined, title: "Change Password" },
    "verify-purchase": { page: VerifyPurchasePage, layout: undefined, title: "Verify Purchase" },
    "404": { page: WowPage404, is404: true, layout: undefined, title: "Page Not Found" },
    profile: { page: ProfilePage, isPrivate: true, title: "Profile" },
    links: { page: LinksPage, isPrivate: true, title: "Links" },
    worlds: { page: WorldsPage, isPrivate: true, title: "Worlds" },
    "worlds/posts": { page: PostsPage, isPrivate: true, title: "World Posts" },
    "live-events": { page: LiveEventsPage, isPrivate: true, title: "Live Events" },
    analytics: { page: AnalyticsPage, isPrivate: true, title: "Analytics" },
    settings: { page: SettingsPage, isPrivate: true, title: "Account Settings" },
    purchases: { page: PurchasesPage, isPrivate: true, title: "Purchases" },
  },
  AppLayout,
);

export const { router, navigateTo } = routerModule;

export type RoutePath = typeof router extends WowRouter<infer T> ? keyof T : never;
